import FleetCoach from "../../services/api/FleetCoach";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath, isValNull } from "../../utils";

const handleError = (err) => {
  console.log("[handleError] Error in FleetCoach actions", err);
};

export const setFleetCoachList = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_LIST,
    payload,
  };
};
export const setFleetCoachActiveObject = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_ACTIVE_OBJECT,
    payload,
  };
};
export const setFleetCoachActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_ACTIVE_FILTERS,
    payload,
  };
};
export const setFleetCoachCurrentPage = (payload) => {
  return {
    type: ActionTypes.SET_FLEET_COACH_CURRENT_PAGE,
    payload,
  };
};

export const getFleetCoachList = (page, activeFilters) => async (dispatch) => {
  let filterBody = [];
  let activeFiltersObj = {};
  const filterKeyMapping = {
    fcId: "fc_id",
    emailId: "email_id",
    phoneNo: "phone_no",
    status: "status",
    cities: "cities",
    zones: "zones",
  };
  Object.keys(activeFilters).map((key, index) => {
    if (!isValNull(activeFilters[key])) {
      Object.assign(activeFiltersObj, { [key]: activeFilters[key] });
      if (
        !(
          filterKeyMapping[key] === "cities" ||
          filterKeyMapping[key] === "zones"
        ) &&
        filterKeyMapping[key] != undefined
      ) {
        filterBody.push({
          key: filterKeyMapping[key],
          value:
            typeof activeFilters[key] === "string"
              ? `'${activeFilters[key]}'`
              : `${activeFilters[key]}`,
        });
      }
    }
  });
  const body = {
    page_request: {
      page: page,
      page_size: 20,
    },
    filters: filterBody,
    filter_cities: activeFilters.cities,
    filter_zones: activeFilters.zones,
  };
  dispatch(setLoader(true));
  try {
    const response = await FleetCoach.getFleetCoachList(body);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setFleetCoachCurrentPage(page));
      dispatch(setFleetCoachList(response));
      dispatch(setFleetCoachActiveFilters(activeFiltersObj));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const saveUpdateFleetCoach = (actionType, body) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const fleetObj = {};
    Object.keys(body).map((key, index) => {
      if (!isValNull(body[key])) {
        Object.assign(fleetObj, { [key]: body[key] });
      }
    });
    const requestBody = {
      data: fleetObj,
    };
    if (requestBody.data.zoneMapping) {
      for (var i = 0; i < requestBody.data.zoneMapping.length; i++) {
        if (requestBody.data.zoneMapping[i].percentage) {
          if (typeof requestBody.data.zoneMapping[i].percentage === "string") {
            if (requestBody.data.zoneMapping[i].percentage.length > 0) {
              requestBody.data.zoneMapping[i].percentage = parseInt(
                requestBody.data.zoneMapping[i].percentage
              );
            }
          }
        } else {
          requestBody.data.zoneMapping[i].percentage = null;
        }
      }
    }
    const response = await FleetCoach.saveUpdateFleetCoach(requestBody);
    dispatch(setLoader(false));
    if (response) {
      if (response.message === "Secondary fleet coach FcId invalid") {
        dispatch(setLoader(false));
        dispatch(
          setStatus({
            type: "error",
            message: response.message,
          })
        );
      } else {
        dispatch(
          setStatus({
            type: "success",
            message:
              actionType === "Add"
                ? SuccessMessages.CREATION_SUCCESS
                : SuccessMessages.UPDATION_SUCCESS,
          })
        );
        return response;
      }
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getFleetCoachDetails = (id) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const response = await FleetCoach.getFleetCoachDetails(id);
    dispatch(setLoader(false));
    if (response) {
      const obj = getPath(response, "fleetCoach", {});
      let fleetDetailObj = {};
      const keyMapping = {
        id: "id",
        first_name: "firstName",
        last_name: "lastName",
        fc_id: "fcId",
        email_id: "emailId",
        phone_no: "phoneNo",
        status: "status",
        profile_image_key: "profileImageKey",
        profile: "profile",
        zones: "zones",
        cities: "cities",
        secondary_fleet_coach_id: "secondaryFcId",
        zone_mapping: "zoneMapping",
        is_test_fleet_coach: "isTestFleetCoach",
        alternate_phone_no: "alternatePhoneNo",
        business: "business",
      };
      Object.keys(obj).map((key) => {
        if (key === "is_test_fleet_coach") {
          if (obj[key] == true) {
            Object.assign(fleetDetailObj, { [keyMapping[key]]: "TRUE" });
          } else {
            Object.assign(fleetDetailObj, { [keyMapping[key]]: "FALSE" });
          }
        } else {
          Object.assign(fleetDetailObj, { [keyMapping[key]]: obj[key] });
        }
      });
      dispatch(setFleetCoachActiveObject(fleetDetailObj));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateFleetCoachDocuments = (id, body) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const response = await FleetCoach.updateFleetCoachDocument(id, body);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
